import { render } from "./HistoryQrCodes.vue?vue&type=template&id=618d3fd2&scoped=true"
import script from "./HistoryQrCodes.vue?vue&type=script&lang=js"
export * from "./HistoryQrCodes.vue?vue&type=script&lang=js"

import "./HistoryQrCodes.vue?vue&type=style&index=0&id=618d3fd2&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-618d3fd2"]])

export default __exports__